import { createContext } from 'react';
import { GeoPoint } from '../location/types';

export const UnitLocationContext = createContext<GeoPoint | undefined>(undefined);
